'use strict';

import VueRouter from 'vue-router';
import authMiddleware from "./middleware/auth"

import HomePage from "./../pages/Home";
import AboutUsPage from "./../pages/AboutUs";
import AfricaPage from "./../pages/Africa";
import CareersPage from "./../pages/Careers";
import ContactUsPage from "./../pages/ContactUs";
import DestinationPage from "./../pages/Destination";
import DestinationsPage from "./../pages/Destinations";
import FestiveToolPage from "./../pages/Festive";
import FlightsPage from "./../pages/Flights";
import HotelPage from "./../pages/Hotel";
import HotelsPage from "./../pages/Hotels";
import ConciergePage from "./../pages/Concierge";
import CovidResourcesPage from "./../pages/CovidResources";
import CareerOpportunitiesPage from "./../pages/CareerOpportunities";
import SpecialOffersPage from "./../pages/SpecialOffers";
import PaymentMethodPage from "./../pages/PaymentMethod";
import MapPage from "./../pages/Map";
import PrivacyPolicyPage from "./../pages/PrivacyPolicy";
import RewardsProgramPage from "./../pages/RewardsProgram";
import FaqPage from "./../pages/Faq";
import AffirmPage from "./../pages/Affirm";
import ProfilePage from "./../pages/Profile";
import NotFoundPage from "./../pages/404";
import Login from "./../controllers/master/Log-in";
import SignUp from "../pages/SignUp";
import PasswordSetup from "../pages/PasswordSetup";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import CFAROffering from "../pages/CFAROffering";
import CFAROfferExpired from "../pages/CFAROfferExpired";
import multiAnalytics from "../../shared-js/multi-analytics";
import TrendingPage from "./../pages/Trending";
import WebinarLibraryPage from "./../pages/WebinarLibrary";
import RegionPage from "./../pages/Region";

const router = new VueRouter({
    linkActiveClass: 'active',
    mode: 'history',
    routes: [
        {
            path: '/',
            component: HomePage,
            name: "home",
        },
        {
            path: '/lo',
            component: Login,
            name: "lo",
        },
        {
            path: '/sign-up',
            component: SignUp,
            name: "sign-up",
        },
        {
            path: '/cfar-offer/:reservationId',
            component: CFAROffering,
            name: "cfar-offer",
        },
        {
            path: '/cfar-offer-expired',
            component: CFAROfferExpired,
            name: "cfar-offer-expired",
        },
        {
            path: '/forgot-password',
            component: ForgotPassword,
            name: "forgot-password",
        },
        {
            path: '/reset-password',
            component: ResetPassword,
            name: "reset-password",
        },
        {
            path: '/password-setup',
            component: PasswordSetup,
            name: "password-setup",
        },
        {
            path: '/about-us',
            component: AboutUsPage,
            name: "about-us",
        },
        {
            path: '/affirm',
            component: AffirmPage,
            name: "affirm",
        },
        {
            path: '/africa',
            component: AfricaPage,
            name: "africa",
        },
        {
            path: '/careers',
            component: CareersPage,
            name: "careers",
        },
        {
            path: '/contact-us',
            component: ContactUsPage,
            name: "contact-us",
        },
        {
            path: '/destinations',
            component: DestinationsPage,
            name: "destinations",
        },
        {
            path: '/destinations/:slug',
            component: DestinationPage,
            name: "destination",
        },
        {
            path: '/festive-tool',
            component: FestiveToolPage,
            name: "festive-tool",
            meta: {
                middleware: authMiddleware,
            },
        },
        {
            path: '/flights',
            component: FlightsPage,
            name: "flights",
        },
        {
            path: '/hotels/:slug',
            component: HotelPage,
            name: "hotel",
        },
        {
            path: '/hotels',
            component: HotelsPage,
            name: "hotels",
        },
        {
            path: '/concierge',
            component: ConciergePage,
            name: "concierge",
        },
        {
            path: '/covid-resources',
            component: CovidResourcesPage,
            name: "covid-resources",
        },
        {
            path: '/career-opportunities',
            component: CareerOpportunitiesPage,
            name: "career-opportunities",
        },
        {
            path: '/special-offers',
            component: SpecialOffersPage,
            name: "special-offers",
        },
        {
            path: '/payment-method',
            component: PaymentMethodPage,
            name: "payment-method",

        },
        {
            path: '/map',
            component: MapPage,
            name: "map",
        },
        {
            path: '/privacy-policy',
            component: PrivacyPolicyPage,
            name: "privacy-policy",
        },
        {
            path: '/rewards-program',
            component: RewardsProgramPage,
            name: "rewards-program",
        },
        {
            path: '/faq',
            component: FaqPage,
            name: "faq",
        },
        {
            path: '/profile',
            component: ProfilePage,
            name: "profile",
            meta: {
                middleware: authMiddleware,
            },
        },
        {
            path: '/trending',
            component: TrendingPage,
            name: "trending",
            meta: {
                middleware: authMiddleware,
            },
        },
        {
            path: '/webinar-library',
            component: WebinarLibraryPage,
            name: "webinar-library",
        },
        {
            path: '/regions/europe',
            component: RegionPage,
            name: "region",
            meta: {
                middleware: authMiddleware,
            },
        },
        {path: '*', component: NotFoundPage}
    ],
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({...context, next: nextMiddleware});
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({...context, next: nextMiddleware});
    }

    return next();
});

router.afterEach((to, from) => {
   multiAnalytics.pageView();
});

export default router;
